





















































































































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import NumUtils from "@/utils/numUtils";
import LoginEntrance from "./LoginEntrance.vue";
import GeneralUtilsHelper from "@/utils/generalUtils";
import * as types from "@/store/constants/types";

@Component({
  components: {
    LoginEntrance
  }
})
export default class UserInfo extends Vue {
  @Prop({ default: "follow" })
  private type!: string;
  @Prop({ default: "" })
  private infoPic?: string;
  @Prop({
    default: () => {
      return {
        insUserInfo: {
          username: "",
          profile_pic_url: "",
          userId: ""
        }
      };
    }
  })
  private insUserInfo?: any;
  @Prop({ default: null })
  private insUserMedia?: any;
  @Prop({ default: "login" })
  private userType?: string;
  @Getter(types.GETTER_CURRENT_INS_MEDIA_LIST_INFO)
  private currentInsMediaListInfo: any;

  get generalStatusHelper() {
    return GeneralUtilsHelper;
  }

  get emptyOfferShow() {
    if (this.type !== "follow" && this.type !== "goldenFollow") {
      if (
        this.insUserMedia === null ||
        this.currentInsMediaListInfo.insMediaList.length === 0
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  get emptyOfferTipShow() {
    if (this.type === "follow" || this.type === "goldenFollow") {
      return false;
    } else {
      if (
        this.currentInsMediaListInfo.insMediaList.length !== 0 &&
        this.insUserMedia === null
      ) {
        //如果只有view为空，或者 普通post为空
        return true;
      } else {
        return (
          this.emptyOfferShow &&
          !this.isPirvateOfferShow &&
          !this.pullingPostShow
        );
      }
    }
  }

  get pirvateOfferTipShow() {
    if (
      this.currentInsMediaListInfo.insMediaList.length !== 0 &&
      this.insUserMedia === null &&
      this.isPirvateOfferShow
    ) {
      return false;
    } else {
      return (
        this.isPirvateOfferShow && this.emptyOfferShow && !this.pullingPostShow
      );
    }
  }

  get pullingPostShow() {
    if (this.type !== "follow" && this.type !== "goldenFollow") {
      if (
        this.currentInsMediaListInfo &&
        this.currentInsMediaListInfo.dataStatus !== "ready"
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  get emptyOfferText() {
    console.log("this.type:", this.type);
    return this.type === "view" ? "No videos yet" : "No posts yet";
  }

  get postInfoShow() {
    return this.type === "follow" || this.type === "goldenFollow"
      ? false
      : true;
  }

  get insFollowersCount() {
    if (this.insUserInfo) {
      return this.insUserInfo.dataStatus !== "ready"
        ? false
        : this.format(this.insUserInfo.insUserInfo.follower_count);
    } else {
      return false;
    }
  }

  get isPirvateOfferShow() {
    console.log("this.type:", this.type);
    return this.type === "follow" || this.type === "goldenFollow"
      ? false
      : this.isPirvateAccount
      ? true
      : false;
  }

  get privateOfferText() {
    return `Account @${this.insUserInfo.userName} is private`;
  }

  get isEmptyAccount() {
    return GeneralUtilsHelper.isEmptyAccount();
  }

  get isPirvateAccount() {
    return GeneralUtilsHelper.isPirvateAccount(this.insUserInfo.insUserInfo);
  }

  get isSearch() {
    return GeneralUtilsHelper.isSearch;
  }

  get format() {
    return NumUtils.format;
  }

  get simplify() {
    return NumUtils.simplify;
  }

  @Emit("click")
  private clickSection() {
    console.log("click section");
  }
}
